import { render, staticRenderFns } from "./Destination_master.vue?vue&type=template&id=89b8f056&"
import script from "./Destination_master.vue?vue&type=script&lang=js&"
export * from "./Destination_master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports